import React, { useRef, useState } from "react"
import { Form, Card } from "react-bootstrap"
import { Button, Typography, Alert, Container, Box, TextField, Stack, Link } from "@mui/material"
import { useAuth } from "../contexts/AuthContext"
import {  useNavigate } from "react-router-dom"


export default function Login() {
  const emailRef = useRef()
  const passwordRef = useRef()
  const { login } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  let navigate = useNavigate()

  async function handleSubmit(e) {

    e.preventDefault()
    try {
      setError("")
      setLoading(true)
      await login(emailRef.current.value, passwordRef.current.value)
      setLoading(false)
      navigate('/');
      // await new Promise(resolve => setTimeout(resolve, 3000))

    } catch (e) {
      // console.log(e)
      setError("Failed to log in")
      setLoading(false)
    } finally {
    }
  }

  return (
    <>
            <Box component="form" onSubmit={handleSubmit} >
              
              <Stack spacing={2} alignItems="center">
              <Typography variant="h1" sx={{ fontWeight: 'bold', fontSize: '2.25vw', marginTop: "20px", fontFamily: 'Prompt' }}>เข้าสู่ระบบ</Typography>
          {error && <Alert severity="error">{error}</Alert>}

            <TextField id='email' label='Email' variant="standard" type="email" inputRef={emailRef} inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}/>
            <TextField id='password' label='Password' variant="standard" type="password" inputRef={passwordRef} inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}/>
            <Button disabled={loading}  type="submit" variant="contained" sx={{fontFamily: 'Prompt' }}>
              เข้าสู่ระบบ
            </Button>
            <Link href="/forgot-password" sx={{fontFamily: 'Prompt' }}>ลืมรหัสผ่าน?</Link>
            </Stack>
            </Box>
    </>
  )
}